import type { TFunction } from "i18next";

import { allSteelSubCategories, categories } from "./data";

const CATEGORY_IDS = new Set(categories.map((category) => category.id));

const STEEL_TYPE_IDS = new Set(allSteelSubCategories.map((sub) => sub.id));

const SCREW_TYPE_KEYS: Record<string, string> = {
  六角螺栓: "hexBolt",
  六角螺帽: "hexNut",
  墊圈: "washer",
  高張力螺絲組: "highStrengthBoltSet",
  錨栓: "anchorBolt",
  剪力釘: "shearStud",
};

export function categoryLabel(
  t: TFunction,
  categoryId: string,
  fallback?: string,
): string {
  const defaultValue = fallback ?? categoryId;
  if (!CATEGORY_IDS.has(categoryId)) return defaultValue;
  return t(`itemEditor.category.${categoryId}`, { defaultValue });
}

export function subTypeLabel(
  t: TFunction,
  categoryId: string,
  subTypeId: string,
  fallback?: string,
): string {
  const defaultValue = fallback ?? subTypeId;
  if (categoryId === "steel" && STEEL_TYPE_IDS.has(subTypeId)) {
    return t(`itemEditor.steelType.${subTypeId}`, { defaultValue });
  }
  if (categoryId === "screw" && SCREW_TYPE_KEYS[subTypeId]) {
    return t(`itemEditor.screwType.${SCREW_TYPE_KEYS[subTypeId]}`, {
      defaultValue,
    });
  }
  return defaultValue;
}
